(function ($) {
    var map;
    function initLLActivityMap(el_id) {
        var $el = $('#'+el_id);
        var zoomLvl = $el.data('zoom');
        var map = L.map(el_id).setView([$el.data('center-lat'), $el.data('center-lng')], zoomLvl);
        
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        var $markers = $('.marker-def');
        var i=0;
        $markers.each(function(index){
            var lat = $(this).data('lat');
            var lng = $(this).data('lng');
            var icon = $(this).data('icon');

            var marker = '';
            if(icon!==""){
                var markerIcon = L.icon({
                    iconUrl: icon,
                    iconSize: [32, 45],
                });
                marker = L.marker([lat, lng],{icon: markerIcon}).bindPopup($(this).html());
            }
            else{
                marker = L.marker([lat, lng]).bindPopup($(this).html());
            }
            //For grouping marker
            //provinceMarkersGroups.push(marker);
            //Comment below line to disable individual marker and enable
            marker.addTo(map);
            var locindex = index;
            $('.activity-location').eq(locindex).on('click',function(e){
                e.preventDefault();
                map.flyTo(new L.LatLng(lat, lng),14);
                marker.openPopup();                
            });
            $('.activity-location').eq(locindex).mouseenter(function(e){                
                $(marker._icon).addClass('hover');      
            });
            $('.activity-location').eq(locindex).mouseleave(function(e){                
                $(marker._icon).removeClass('hover');      
            });
            i++;
        });
        return map;
    }

    
    $(function() {
        $('.activity a').magnificPopup({
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: true,
            mainClass: 'mfp-with-zoom mfp-img-mobile mfp-gallery',
            image: {
                verticalFit: true,
            },
            gallery: {
                enabled: false,
            },
            zoom: {
                enabled: true,
                duration: 300, // don't foget to change the duration also in CSS
                opener: function(element) {
                    return element.find('img');
                }
            }		
        });
        $('.act-listview').on('click',function(e){
            e.preventDefault();
            $('.activities-map-wrapper').removeClass('active');
            $('.act-listview').addClass('active');
            $('.act-mapview').removeClass('active');
            $('.activities-wrapper').addClass('active');
        });
        $('.act-mapview').on('click',function(e){
            e.preventDefault();
            $('.activities-wrapper').removeClass('active');
            $('.act-mapview').addClass('active');
            $('.act-listview').removeClass('active');
            $('.activities-map-wrapper').addClass('active');
            if(map === undefined || map === null ){
                map = initLLActivityMap( 'acf-activity-map' );
            }
        });
        if($(window).innerWidth() < 1000){
            $(document).on('click','.activities-map-wrapper .showdestination',function(){
                $('.activities-map-wrapper .activities-list').addClass('active');
            });
            $(document).on('click','.activities-map-wrapper .close',function(){
                $('.activities-map-wrapper .activities-list').removeClass('active');
            });
        }
    });
})(jQuery);